export const SYSTEM_NOTIFICATIONS_RECEIVED = "SYSTEM_NOTIFICATIONS_RECEIVED";
export const SYSTEM_NOTIFICATION_ACKNOWLEDGED = "SYSTEM_NOTIFICATION_ACKNOWLEDGED";
export const SYSTEM_NOTIFICATIONS_CLEARED = "SYSTEM_NOTIFICATIONS_CLEARED";
